module.exports = __webpack_public_path__ + "img/after school as usual.d80edc5e.png";